export default __webpack_public_path__ + "static/media/IMG_8074.07292d5c.jpg";